/**
 * Generated by orval
 * Do not edit manually
 * WorkflowXMApi, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */

export type WorkflowVersionStatus = (typeof WorkflowVersionStatus)[keyof typeof WorkflowVersionStatus];

export const WorkflowVersionStatus = {
  Inactive: 0,
  Active: 1,
  Pending: 2,
  Migrating: 3,
} as const;
